import { useState } from "react";
import { NavLink } from "react-router-dom";

import image1 from "../img/utpl.png";

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 bg-[#004270] backdrop-blur-md border-b border-slate-100 shadow-sm">
      <div className="max-w-6xl mx-auto px-6 h-20 flex items-center justify-between">
        
        {/* LOGO */}
        <NavLink to="/" className="flex items-center transition-transform hover:scale-105">
          <img src={image1} alt="utpl" className="h-8 w-auto object-contain" />
        </NavLink>

        {/* MENÚ DE ESCRITORIO */}
        <nav className="hidden md:flex items-center gap-8">
          <a href="#inicio" className="text-sm font-medium text-slate-100 hover:text-amber-300 transition-colors">
            Inicio
          </a>
          <a href="#objetivos" className="text-sm font-medium text-slate-100 hover:text-amber-300 transition-colors">
            Objetivos
          </a>
          <a href="#actividades" className="text-sm font-medium text-slate-100 hover:text-amber-300 transition-colors">
            Actividades
          </a>
          <a href="#lineas" className="text-sm font-medium text-slate-100 hover:text-amber-300 transition-colors">
            Líneas temáticas
          </a>
          <a href="#agenda" className="text-sm font-medium text-slate-100 hover:text-amber-300 transition-colors">
            Agenda
          </a>

             <a href="#loja" className="text-sm font-medium text-slate-100 hover:text-amber-300 transition-colors">
            Loja
          </a>
          <a 
            href="#inscribete" 
            className="text-sm font-semibold text-[#004270] bg-[#febe10] hover:text-white px-5 py-2.5 rounded-full transition-all shadow-sm hover:shadow-md"
          >
            Inscríbete ahora
          </a>
        </nav>

        {/* BOTÓN HAMBURGUESA (MÓVIL) */}
        <button
          onClick={() => setMenuOpen(!menuOpen)}
          className="md:hidden p-2 rounded-lg text-slate-600 hover:text-slate-900 hover:bg-slate-100 focus:outline-none transition-colors"
          aria-label="Abrir menú"
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            {menuOpen ? (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
            ) : (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
            )}
          </svg>
        </button>
      </div>

      {/* MENÚ MÓVIL (DESPLEGABLE) */}
      {menuOpen && (
        <div className="md:hidden bg-white border-b border-slate-100 px-6 pt-2 pb-6 flex flex-col gap-4 shadow-lg">
          <a 
            href="#inicio" 
            onClick={() => setMenuOpen(false)}
            className="text-base font-medium text-slate-700 hover:text-indigo-600 py-1"
          >
            Inicio
          </a>
          <a 
            href="#objetivos" 
            onClick={() => setMenuOpen(false)}
            className="text-base font-medium text-slate-700 hover:text-indigo-600 py-1"
          >
            Objetivos
          </a>
          <a 
            href="#actividades" 
            onClick={() => setMenuOpen(false)}
            className="text-base font-medium text-slate-700 hover:text-indigo-600 py-1"
          >
            Actividades
          </a>
          <a 
            href="#lineas" 
            onClick={() => setMenuOpen(false)}
            className="text-base font-medium text-slate-700 hover:text-indigo-600 py-1"
          >
            Líneas temáticas
          </a>
          <a 
            href="#agenda" 
            onClick={() => setMenuOpen(false)}
            className="text-base font-medium text-slate-700 hover:text-indigo-600 py-1"
          >
            Agenda
          </a>
          <a 
            href="#inscribete" 
            onClick={() => setMenuOpen(false)}
            className="text-center text-base font-semibold text-white bg-indigo-600 hover:bg-indigo-700 px-5 py-3 rounded-xl transition-all mt-2"
          >
            Inscríbete ahora
          </a>
        </div>
      )}
    </header>
  );
}

export default Header;